export default __webpack_public_path__ + "static/media/2412256.2d6f43df.webp";